module.exports = __webpack_public_path__ + "static/media/high-supply-vice-logo.a1583fe4.png";